import axios from 'axios';
import TokenService from './token-service';

let baseURL = '';

if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
  baseURL = 'https://us-central1-b-line-219713.cloudfunctions.net/b-line-predictive-analysis-prod';
} else {
  baseURL = 'https://us-central1-b-line-219713.cloudfunctions.net/b-line-predictive-analysis-dev';
}

// Create an axios instance for the forecast service
const forecastInstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to include the authorization token
forecastInstance.interceptors.request.use(
  (config: any) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default forecastInstance;
